$(document).ready(function() {
  $('.faq-nav-link').click(function(e){
   $('.faq-nav-link').removeClass('active');
   $(this).addClass('active'); 
  });
  $('.faq-block_item-header').click(function(){
   $(this).toggleClass('active');
   $(this).next('.faq_answer_para').slideToggle();
  });
  $("#faq-select_title").on("click", function(a) {
    $("#customSelect").toggleClass("on");
    a.stopPropagation()
  });
  $(document).on("click", function(a) {
    if ($(a.target).is("#customSelect") === false) {
      $("#customSelect").removeClass("on");
    }
  });
  $('.product_tab_link').click(function(){
    $('.product_tab_link').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });
  $('body').on('click', '.product-adjust', function(){
    var ip = parseInt($(this).parent().find('input').val());
    if($(this).hasClass('bfp-info-qty_plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    $(this).parent().find('input').val(ip);
  });

  $('.acordian-header').click(function(){
    $(this).toggleClass('active');
    $(this).next('.acordian-content').slideToggle();
  });

  $('.announcement-bar__static-list').slick({
    infinite: true,
    slidesToShow: 1,
    vertical: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
  });

  $(window).scroll(function() {
    if ($('product-quick-add').length) {
      var Product_up = $('.shopify-section--main-product').offset().top;
      var product_section_height = $('.shopify-section--main-product').outerHeight();
      var full_scroll = Product_up + product_section_height - $('#shopify-section-header').outerHeight();
      if ($(this).scrollTop() > full_scroll) {
        if ($(this).scrollTop() < ($('footer').offset().top - $('#shopify-section-header').outerHeight() - $('product-quick-add').outerHeight() - 20)) {
          $('body product-quick-add').addClass('is-visible');
        } else {
          $('body product-quick-add').removeClass('is-visible');
        }
      } else {
        $('body product-quick-add').removeClass('is-visible');
      }
    }
  });
  
});

